import { formatDateShort } from './formatters';

// UX: Ein Anzeigename pro Objekt, der technische Name wandert in den Tooltip.
// Reine Darstellung: Filter und API-Parameter nutzen weiterhin die Originalwerte.

// Kürzel, die als Akronym groß geschrieben werden, z. B. "fol_kooperation" → "FOL Kooperation".
const ACRONYM_MAX = 3;

function capitalize(token) {
  if (!token) return token;
  return token.charAt(0).toUpperCase() + token.slice(1);
}

// Ist der Wert ein technischer Bezeichner (snake_case/kebab-case ohne Leerzeichen)?
function isTechnicalName(value) {
  const text = String(value || '');
  return /^[a-z0-9]+([_-][a-z0-9]+)+$/i.test(text) && !/\s/.test(text);
}

// UX: "fol_kooperation" → "FOL Kooperation". Freitext bleibt unverändert.
export function humanizeName(value) {
  if (value === null || value === undefined || value === '') return '–';
  const text = String(value);
  if (!isTechnicalName(text)) return text;
  return text
    .split(/[_-]+/)
    .map((token) => (token.length <= ACRONYM_MAX && /^[a-z]+$/.test(token) ? token.toUpperCase() : capitalize(token)))
    .join(' ');
}

// UX: Ein "/" allein sagt nichts. Die Startseite bekommt einen Klartext-Namen.
export function landingPageLabel(value) {
  if (value === null || value === undefined || value === '') return '–';
  const text = String(value);
  if (text === '/') return 'Startseite (/)';
  return text;
}

function commonPrefix(parts) {
  if (parts.length < 2) return 0;
  let index = 0;
  while (parts.every((tokens) => tokens[index] !== undefined && tokens[index] === parts[0][index])) {
    index += 1;
  }
  // Mindestens ein unterscheidendes Segment übrig lassen.
  const shortest = Math.min(...parts.map((tokens) => tokens.length));
  return Math.min(index, shortest - 1);
}

const MONTHS = new Set([
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
]);

/**
 * UX: Mailing-Namen waren im Diagramm als 4 × "Mental Health Newslette…" nicht
 * unterscheidbar. Gemeinsamen Präfix entfernen, Monatsnamen weglassen (das
 * Versanddatum wird angehängt), Einzelwörter zusammenziehen:
 *   "Mental Health Newsletter_Woche 1_Mai_Business_Transformation" (4.5.)
 *   → "Woche 1 · Business Transformation · 4.5."
 * Gibt eine Map id → { label, full } zurück.
 */
export function mailingDisplayNames(rows) {
  const list = (rows || []).map((row) => ({
    id: String(row.id ?? row.name),
    full: String(row.name || ''),
    date: row.sent_at,
    tokens: String(row.name || '').split('_').map((token) => token.trim()).filter(Boolean)
  }));
  const prefix = commonPrefix(list.map((item) => item.tokens));
  const map = {};
  list.forEach((item) => {
    const segments = [];
    let words = [];
    item.tokens.slice(prefix).filter((token) => !MONTHS.has(token)).forEach((token) => {
      if (/\s/.test(token)) {
        if (words.length) segments.push(words.join(' '));
        words = [];
        segments.push(token);
      } else {
        words.push(token);
      }
    });
    if (words.length) segments.push(words.join(' '));
    const date = formatDateShort(item.date);
    const base = segments.length ? segments.join(' · ') : item.full;
    map[item.id] = {
      label: date ? `${base} · ${date}` : base,
      full: item.full
    };
  });
  return map;
}
